// extracted by mini-css-extract-plugin
export default {"poweredByGiphy":"PoweredByGiphy_poweredByGiphy__cwANJ"};